import { Action, configureStore, createAction } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import thunk, { ThunkAction } from 'redux-thunk';
import { AppState, appReducer } from "../core/app/AppReducer";

const persistConfig = {
    key: 'root',
    storage,
    version: parseInt((process.env.REACT_APP_VERSION ?? '1').replace('.', '')),
    whitelist: ['appContext', 'ui']
  }
  
  export const revertAll = createAction('REVERT_ALL')
  
  const persistedAppReducer = persistReducer(persistConfig, appReducer)
  
  const appStore = configureStore({
    //reducer: appReducer,
    reducer: persistedAppReducer,
    // middleware: [thunk, signalrMiddleware],
    middleware: [thunk],
  });
  
  export const appPersistor = persistStore(appStore)
  
  export type AppDispatch = typeof appStore.dispatch;
  
  export type AppThunk = ThunkAction<
    void,
    AppState,
    unknown,
    Action<string>
  >;
  
  export default appStore;